import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, TicketLineDTO, TicketLineStatus, Res } from 'core/api';
import { Command } from 'pos/common';
import * as SalesStore from 'pos/modules/main/SalesStore';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		prepareTicketLine: (line: TicketLineDTO) => Promise<Result>
	}
}

Command.register('prepareTicketLine', Preconditions.ensure(Permission.Ticket_PrepareTicketLine), async (line: TicketLineDTO): Promise<Result> => {
	if (line.Status !== TicketLineStatus.New) {
		await Message.show(Res.Msg.MSG_TICKET_TICKET_LINE_CANNOT_BE_PREPARED());
		return Result.error();
	}

	await SalesStore.prepareLine(line.Id);
	return Result.ok();

});